import i18n from "src/i18n/config";

export const fullOnly = "fullOnly";
export const fullAndIncremental = "fullAndIncremental";

/**
 * Maps the stored `ota.disableIncremental` flag to the OTA packages select and back.
 */
export const otaPackagesFieldConfig = {
    format: (value: boolean | undefined) => (value ? fullOnly : fullAndIncremental),
    parse: (value: string | number | undefined) => value === fullOnly,
};

/**
 * The read-only visibility of an existing product: its owner, or "Public firmware" in place of the owner, followed by
 * any further public properties, plus the tooltip explaining why it cannot be changed.
 */
export const getProductVisibility = (flags: string[], ownerName: string | undefined) => {
    const isPublicFirmware = flags.includes("PublicFirmware");
    const publicProperties = [
        flags.includes("PublicInheritance") ? i18n.t("pages:adminProductsPage.visibility.publicInheritance") : null,
        flags.includes("PublicDeviceRegistration") ? i18n.t("pages:adminProductsPage.visibility.publicDeviceRegistration") : null,
    ].filter((property) => property !== null);

    const text = [isPublicFirmware ? i18n.t("pages:adminProductsPage.visibility.publicFirmware") : ownerName, ...publicProperties]
        .filter(Boolean)
        .join(" · ");

    let tooltip = i18n.t("pages:productPage.tooltip.productsCannotBeMoved");
    if (isPublicFirmware) {
        tooltip = i18n.t("pages:productPage.tooltip.publicFirmware");
    } else if (publicProperties.length) {
        tooltip = i18n.t("pages:productPage.tooltip.productsCannotBeMovedPublicProperties");
    }

    return { text, tooltip };
};
